import * as yup from "yup";

const editProfileSchema = yup.object().shape({
  firstName: yup.string().required("First Name is required"),
  lastName: yup.string().required("Last Name is required"),
  addressLine1: yup.string().required("Address is required"),
  city: yup.string().required("City is required"),
  stateCode: yup.string().required("State is required"),
  countryCode: yup.string().required("Country Code  is required"),
  companyCountryCode: yup
    .string()
    .required("Company Country Code  is required"),
  postalCode: yup.string().required("Zip is required"),
  userEmail: yup
    .string()
    .email("Invalid email id")
    .required("Email Id is required"),
  phoneNumber: yup
    .string()
    .required("Phone Number is required")
    .matches(/^\d{10}$/, "Invalid phone number"),
  companyName: yup.string().required("Company Name is required"),
  companyAddressLine1: yup.string().required("Address is required"),
  companyCity: yup.string().required("City is required"),
  companyStateCode: yup.string().required("State is required"),
  companyPostalCode: yup.string().required("Zip is required"),
  companyPhoneNumber: yup
    .string()
    .required("Phone Number is required")
    .matches(/^\d{10}$/, "Invalid phone number"),
  companyEmail: yup
    .string()
    .email("Invalid email id")
    .required("Email Id is required"),
});

export default editProfileSchema;
